import {
  RECURRENCE_UNITS,
  isValidCivilDate,
  parseCivilDate,
} from '../../domain/finance';

export const NO_RECURRENCE = 'none';
export const RECURRENCE_END_NEVER = 'never';
export const RECURRENCE_END_ON_DATE = 'date';

export const recurrenceValue = (unit, interval) => `${unit}:${interval}`;

export const RECURRENCE_OPTIONS = Object.freeze([
  Object.freeze({ value: NO_RECURRENCE, label: 'Não repetir', unit: null, interval: null }),
  Object.freeze({ value: recurrenceValue(RECURRENCE_UNITS.WEEK, 1), label: 'Semanalmente', unit: RECURRENCE_UNITS.WEEK, interval: 1 }),
  Object.freeze({ value: recurrenceValue(RECURRENCE_UNITS.WEEK, 2), label: 'A cada 2 semanas', unit: RECURRENCE_UNITS.WEEK, interval: 2 }),
  Object.freeze({ value: recurrenceValue(RECURRENCE_UNITS.MONTH, 1), label: 'Mensalmente', unit: RECURRENCE_UNITS.MONTH, interval: 1 }),
  Object.freeze({ value: recurrenceValue(RECURRENCE_UNITS.YEAR, 1), label: 'Anualmente', unit: RECURRENCE_UNITS.YEAR, interval: 1 }),
]);

export const getRecurrenceOption = (value) => (
  RECURRENCE_OPTIONS.find((option) => option.value === value) || null
);

export const getRecurrenceValueForSchedule = (schedule) => (
  RECURRENCE_OPTIONS.find((option) => (
    option.unit === schedule?.unit && option.interval === schedule?.interval
  ))?.value || NO_RECURRENCE
);

export const buildRecurrenceFormInput = ({ repeat, anchorDate, endMode, untilDate }) => {
  if (repeat === NO_RECURRENCE) return { ok: true, recurrence: null, errors: {} };

  const option = getRecurrenceOption(repeat);
  const errors = {};

  if (!option || !option.unit || !Number.isInteger(option.interval) || option.interval <= 0) {
    errors.repeat = 'Selecione uma frequência válida.';
  }
  if (!isValidCivilDate(anchorDate)) {
    errors.anchorDate = 'Informe uma data inicial válida.';
  }
  if (![RECURRENCE_END_NEVER, RECURRENCE_END_ON_DATE].includes(endMode)) {
    errors.endMode = 'Selecione quando a recorrência termina.';
  }
  if (endMode === RECURRENCE_END_ON_DATE) {
    if (!isValidCivilDate(untilDate)) {
      errors.untilDate = 'Informe uma data final válida.';
    } else if (isValidCivilDate(anchorDate) && untilDate < anchorDate) {
      errors.untilDate = 'A data final não pode ser anterior à data inicial.';
    }
  }

  if (Object.keys(errors).length > 0) return { ok: false, recurrence: null, errors };

  return {
    ok: true,
    recurrence: {
      unit: option.unit,
      interval: option.interval,
      untilDate: endMode === RECURRENCE_END_ON_DATE ? untilDate : null,
    },
    errors: {},
  };
};

const MONTH_NAMES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

export const formatLongCivilDate = (date) => {
  const parsed = parseCivilDate(date);
  return parsed ? `${parsed.day} de ${MONTH_NAMES[parsed.month - 1]} de ${parsed.year}` : '';
};

export const getRecurrencePreview = ({ repeat, anchorDate, endMode, untilDate }) => {
  const option = getRecurrenceOption(repeat);
  const formattedAnchor = formatLongCivilDate(anchorDate);
  if (!option?.unit || !formattedAnchor) return '';

  const frequency = {
    [recurrenceValue(RECURRENCE_UNITS.WEEK, 1)]: 'semanalmente',
    [recurrenceValue(RECURRENCE_UNITS.WEEK, 2)]: 'a cada 2 semanas',
    [recurrenceValue(RECURRENCE_UNITS.MONTH, 1)]: 'mensalmente',
    [recurrenceValue(RECURRENCE_UNITS.YEAR, 1)]: 'anualmente',
  }[repeat];
  const formattedUntil = endMode === RECURRENCE_END_ON_DATE
    ? formatLongCivilDate(untilDate)
    : '';

  return `Repete ${frequency} a partir de ${formattedAnchor}${formattedUntil ? ` até ${formattedUntil}` : ''}.`;
};
